<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="fs-5 fw-bold mb-0">Goals</h1>
  <div class="d-flex gap-2">
    <a [routerLink]="['add']" *isGranted="['ROLE_API_GOAL_WRITE']" class="btn btn-primary fw-bold"><i class="bi bi-plus-lg me-2"></i>Add Goal
  </a>
</div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead>
          <tr [tableSorter]="tableSorter" (tableSorterChange)="refresh()">
            <th tableSorterHeader="id">ID</th>
            <th tableSorterHeader="name">Name</th>
            <th>Add to revenue</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (goal of goals; track goal) {
            <tr>
              <td>{{ goal.id }}</td>
              <td>{{ goal.name }}</td>
              <td>
                @if (goal.addToRevenue) {
                  <span class="badge bg-success">Yes</span>
                }
                @if (!goal.addToRevenue) {
                  <span class="badge bg-danger">No</span>
                }
              </td>
              <td class="text-center">
                <a class="btn btn-outline-primary btn-sm" [routerLink]="[goal.id]"><i class="bi bi-pencil me-1"></i>Edit</a>
                <button *isGranted="['ROLE_API_GOAL_WRITE']" class="btn btn-outline-danger btn-sm ms-1" appConfirm (click)="delete(goal)"><i class="bi bi-trash"></i></button>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <app-paginator (pageChange)="refresh()" [paginator]="paginator"></app-paginator>
    </div>
  </div>
</div>
